import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-content-aside-recommend" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "recommend-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img" })
], -1)
const _hoisted_3 = { class: "recommend-text" }
const _hoisted_4 = { class: "recommend-link" }
const _hoisted_5 = { class: "link-email" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "https://space.bilibili.com/24731556/?spm_id_from=333.999.0.0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-youxiang_" })
], -1)
const _hoisted_7 = { class: "link-github" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { href: "https://space.bilibili.com/24731556/?spm_id_from=333.999.0.0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-githubb" })
], -1)
const _hoisted_9 = { class: "link-gitee" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "https://space.bilibili.com/24731556/?spm_id_from=333.999.0.0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-gitee" })
], -1)
const _hoisted_11 = { class: "link-bilibili" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { href: "https://space.bilibili.com/24731556/?spm_id_from=333.999.0.0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-icon_bilibili-circle" })
], -1)
const _hoisted_13 = { class: "link-qq" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { href: "https://space.bilibili.com/24731556/?spm_id_from=333.999.0.0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-QQ-circle-fill" })
], -1)


const __default__ = { name: 'HomeContentAsideRecommend' };

import '@/assets/svg/home-svg/fonticon/iconfont.css';
import {reactive, ref, onBeforeMount, onMounted} from 'vue';



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

onMounted(() => {
  // console.log('3.-组件挂载到页面之后执行-------onMounted');
});
expose({
});

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('home_content_aside_recommend.recommend_text1')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('home_content_aside_recommend.recommend_text2')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_popover, {
          placement: "top",
          title: "",
          trigger: "hover",
          content: "邮箱",
          "popper-class": "popover-recommend-link",
          width: "Min width 150px"
        }, {
          reference: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_popover, {
          placement: "top",
          title: "",
          trigger: "hover",
          content: "github",
          "popper-class": "popover-recommend-link",
          width: "Min width 150px"
        }, {
          reference: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_popover, {
          placement: "top",
          title: "",
          trigger: "hover",
          content: "gitee",
          "popper-class": "popover-recommend-link",
          width: "Min width 150px"
        }, {
          reference: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_popover, {
          placement: "top",
          title: "",
          trigger: "hover",
          content: "bilibili",
          "popper-class": "popover-recommend-link",
          width: "Min width 150px"
        }, {
          reference: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_popover, {
          placement: "top",
          title: "",
          trigger: "hover",
          content: "QQ",
          "popper-class": "popover-recommend-link",
          width: "Min width 150px"
        }, {
          reference: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})